export enum EnvironmentType {
    Local = 'Local',
    Dev = 'Dev',
    QA = 'QA',
    Sand = 'Sand',
    Production = 'Production',
}
